var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"16px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.introduce.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }